import Cookies from 'js-cookie';
import { COOKIES } from '@/lib/models';

export function constructUrl(
	baseUrl: string,
	queryParameters?: Record<string, any> | URLSearchParams | string
) {
	if (!queryParameters) {
		return baseUrl;
	}

	if (queryParameters instanceof URLSearchParams) {
		const queryString = queryParameters.toString();
		return queryString ? `${baseUrl}?${queryString}` : baseUrl;
	}

	if (typeof queryParameters === 'string') {
		const queryString = queryParameters.startsWith('?')
			? queryParameters.slice(1)
			: queryParameters;
		return queryString ? `${baseUrl}?${queryString}` : baseUrl;
	}

	const searchParams = new URLSearchParams();
	Object.keys(queryParameters).forEach((key) => {
		const value = queryParameters[key];

		if (Array.isArray(value)) {
			value.forEach((entry) => {
				if (entry !== undefined && entry !== null) {
					searchParams.append(key, String(entry));
				}
			});
			return;
		}

		if (value !== undefined && value !== null) {
			searchParams.append(key, String(value));
		}
	});

	const queryString = searchParams.toString();
	return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}

export function getParsedQuery(query: URLSearchParams) {
	const parsedQuery: Record<string, any> = {};

	for (const keyValuePair of query.entries()) {
		const key = keyValuePair[0];
		const value = keyValuePair[1];

		if (parsedQuery[key]) {
			if (Array.isArray(parsedQuery[key])) {
				parsedQuery[key].push(value);
			} else {
				const previousValue = parsedQuery[key];
				parsedQuery[key] = [previousValue, value];
			}
		} else {
			parsedQuery[key] = value;
		}
	}

	return parsedQuery;
}

export const handleDangerousHtmlClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
	const anchorElement = event.currentTarget.querySelector('a');

	if (anchorElement && event.currentTarget.contains(anchorElement)) {
		Cookies.set(COOKIES.UPDATE_CREDENTIALS_LINK_CLICKED, 'true');
	}
};
